var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-display_inline" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "div",
        { key: item.name, staticClass: "eu-display_inline" },
        [
          _c(
            "router-link",
            {
              staticClass: "emd-link",
              attrs: { to: { name: item.routeName } },
            },
            [_c("app-breadcrumb-item", { attrs: { name: item.name } })],
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }